// extracted by mini-css-extract-plugin
export var link = "PortfolioPage-module--link--12j2g";
export var mainWrapper = "PortfolioPage-module--mainWrapper--5RPQI";
export var projectTitle = "PortfolioPage-module--projectTitle--+Hws2";